//read apiurl from .env file
// const API_URL = process.env.REACT_APP_API_URL;
const API_URL = "http://localhost:3000";

export {API_URL};
